import React, { FC } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import PruRoute from 'src/app/common/components/PruRoute';
import {
  WALLET_BASE_PATH,
  WALLET_BULKUPLOAD_PATH,
  WALLET_BULKUPLOAD_UPLOAD_CREDIT_PATH,
  WALLET_BULKUPLOAD_UPLOAD_PATH,
} from '../../../../../constants';
import BulkUploadCreditPage from './BulkUploadCreditPage';

export const uploadPath = `${WALLET_BASE_PATH}${WALLET_BULKUPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_PATH}${WALLET_BULKUPLOAD_UPLOAD_CREDIT_PATH}`;

const BulkUploadCreditRoutes: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Redirect exact from={uploadPath} to={`${uploadPath}/list`} />
      <PruRoute exact path={`${uploadPath}/list`} component={BulkUploadCreditPage} />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default BulkUploadCreditRoutes;
